import { Component, Event, EventEmitter, h, Host, Prop, Watch } from '@stencil/core'

/**
 * ## Design System
 *
 * O `br-select-option` é um subcomponente lógico de `br-select`, usado para
 * declarar opções de forma declarativa no HTML.
 *
 * @slot default - Texto opcional da opção. Usado como fallback para `label`.
 */
@Component({
  tag: 'br-select-option',
  shadow: true,
})
export class SelectOption {
  /**
   * Rótulo da opção. Quando omitido, o texto do slot é usado.
   */
  @Prop({ reflect: true }) label?: string

  /**
   * Valor da opção.
   */
  @Prop({ reflect: true }) value?: string

  /**
   * Indica se a opção está selecionada.
   */
  @Prop({ reflect: true }) selected: boolean = false

  /**
   * Notifica o componente pai sobre mudanças de props ou conteúdo.
   */
  @Event({ bubbles: true, composed: true }) brSelectOptionPropsChange!: EventEmitter<void>

  @Watch('label')
  @Watch('value')
  @Watch('selected')
  handlePropsChange() {
    this.brSelectOptionPropsChange.emit()
  }

  render() {
    return (
      <Host style={{ display: 'none' }}>
        <slot onSlotchange={() => this.brSelectOptionPropsChange.emit()}></slot>
      </Host>
    )
  }
}
